import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { debounce } from 'lodash';
import domReady from '../helpers/dom-ready';

class Menu {
  static init() {
    return new Menu();
  }

  constructor() {
    this.menu = document.querySelector('.brix-menu');
    this.logo = document.querySelector('.logo');
    this.toggleMenuButton = this.menu.querySelector('.menu-button');
    this.menuWrapper = this.menu.querySelector('.menu-wrapper');
    this.menuList = this.menu.querySelector('.menu');

    // Search
    this.searchForm = this.menu.querySelector('.search-form');

    if (this.searchForm) {
      this.toggleSearchButton = this.menu.querySelector('.toggle-search-button');
      this.searchTextInput = this.searchForm.querySelector('.search-input');
      this.searchButton = this.searchForm.querySelector('.search-button');
    }

    // Language switcher
    this.languageSwitcher = this.menu.querySelector('.language-switcher > select');

    this.isMenuOpen = false;
    this.overflowBreakpoint = null;

    this.addEventListeners();
    this.checkOverflow();
  }

  addEventListeners() {
    window.addEventListener('resize', debounce(() => {
      this.checkOverflow();
      this.checkOpenMenu();
    }), 300);

    window.addEventListener('scroll', debounce(() => {
      this.toggleSolidBackground();
    }), 300);

    this.toggleMenuButton.addEventListener('click', () => {
      this.toggleIsMenuOpen();
    });

    this.menu.addEventListener('transitionend', (e) => {
      if (e.target !== this.menu) { return; }

      // if (e.propertyName === 'height') {
      //   console.log('transitionend - height');
      //   // this.menu.classList.remove('-closing');
      // }

      if (e.propertyName === 'transform') {
        this.menu.classList.remove('-closing');
      }

      // if (e.propertyName === 'background-color') {
      //   console.log('transitionend - background-color');
      // }
    });

    if (this.searchForm) {
      this.toggleSearchButton.addEventListener('click', () => {
        this.toggleIsSearchOpen();
      });

      this.searchButton.addEventListener('click', (e) => {
        this.search(e);
      });
    }

    if (this.languageSwitcher) {
      this.languageSwitcher.addEventListener('change', () => {
        this.changeLanguage();
      });
    }
  }

  checkOverflow() {
    const isOverflowing = this.menuWrapper.clientWidth < this.menuWrapper.scrollWidth;

    if (!this.overflowBreakpoint && isOverflowing) {
      this.overflowBreakpoint = window.innerWidth;
      this.menu.classList.add('-overflow');
    }

    if (this.overflowBreakpoint && window.innerWidth > this.overflowBreakpoint) {
      this.overflowBreakpoint = null;
      this.menu.classList.remove('-overflow');
    }
  }

  checkOpenMenu() {
    const breakpoint = this.overflowBreakpoint ? this.overflowBreakpoint : 576;

    if (window.innerWidth > breakpoint && this.isMenuOpen) {
      this.toggleIsMenuOpen();
    }
  }

  toggleSolidBackground() {
    if (document.body.classList.contains('-menu-type-transparent')) {
      if (window.scrollY > 50) {
        this.menu.classList.add('-solid-background');
      } else {
        this.menu.classList.remove('-solid-background');
      }
    }
  }

  toggleIsMenuOpen() {
    this.menu.classList.toggle('-open-menu');
    this.isMenuOpen = !this.isMenuOpen;

    if (this.isMenuOpen) {
      disableBodyScroll(this.menu);
    } else {
      enableBodyScroll(this.menu);
      this.menu.classList.add('-closing');
    }
  }

  toggleIsSearchOpen() {
    this.menu.classList.toggle('-open-search');
    this.isSearchOpen = !this.isSearchOpen;

    if (this.isSearchOpen) {
      disableBodyScroll(this.menu);

      if (!this.toggleSearchButton.querySelector('.line')) {
        const line = document.createElement('span');
        line.classList.add('line');
        this.toggleSearchButton.appendChild(line);
      }

      this.searchTextInput.focus();
    } else {
      enableBodyScroll(this.menu);
      this.menu.classList.add('-closing');
    }
  }

  search(e) {
    e.preventDefault();

    if (this.searchTextInput.value === '') {
      this.searchTextInput.focus();
    } else {
      const { searchUrl } = this.searchForm.dataset;
      const searchQuery = encodeURIComponent(this.searchTextInput.value).replace(/%20/g, '+');

      window.location.href = `${searchUrl}?search=${searchQuery}`;
    }
  }

  changeLanguage() {
    const option = this.languageSwitcher.options[this.languageSwitcher.selectedIndex];

    if (option && option.value) {
      if (option.dataset.slug && window.pll_set_current_language) {
        window.pll_set_current_language(option.dataset.slug);
      }

      window.location.href = option.value;
    }
  }
}

domReady(() => {
  Menu.init();
});
